
import MasterSeal from './MasterSeal.vue'
import BaseSeal from './BaseSeal.vue'
import ArrowsSeal from './ArrowsSeal.vue'
import HsrSeal from './HsrSeal.vue'
import PerformanceSeal from './PerformanceSeal.vue'
import EquitySeal from './EquitySeal.vue'
import WasSeal from './WasSeal.vue'
import { initVideoIcon } from '~/mixins/inlineVideoIcon'

export default {
  components: {
    MasterSeal,
    BaseSeal,
    ArrowsSeal,
    HsrSeal,
    PerformanceSeal,
    EquitySeal,
    WasSeal,
    VideoPlayer: () => import('~/components/Modules/Common/VideoPlayer'),
  },
  mixins: [initVideoIcon],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      swipeContainer: null,
      navEl: null,
      showModal: false,
      sectionHeight: null,
      sections: [],

      startTl: null,
      arrowsTl: null,
      hsrTl: null,
      performanceTl: null,
      equityTl: null,
      wasTl: null,
      sealTextTl: null,

      bgColors: [
        // 'linear-gradient(123.23deg, #F8F8FA 4.62%, #F8F8FA 39.87%, #F8F8FA 50.9%, #F8F8FA 60.97%, #F8F8FA 89.75%)',
        // 'linear-gradient(123.23deg, #F8F8FA 4.62%, #F8F8FA 39.87%, #F8F8FA 50.9%, #F8F8FA 60.97%, #F8F8FA 89.75%)',
        // 'linear-gradient(123.23deg, #7FB3DC 4.62%, #7FB3DC 39.87%, #7FB3DC 50.9%, #7FB3DC 60.97%, #7FB3DC 89.75%)',
        // 'linear-gradient(123.23deg, #0B667F 4.62%, #0B667F 39.87%, #0B667F 50.9%, #0B667F 60.97%, #0B667F 89.75%)',
        // 'linear-gradient(123.23deg, #41937D 4.62%, #41937D 39.87%, #41937D 50.9%, #41937D 60.97%, #41937D 89.75%)',
        // 'linear-gradient(123.23deg, #7FB3DC 4.62%, #1E738F 39.87%, #0B667F 50.9%, #126D81 60.97%, #41937D 89.75%)',
        '#F8F8FA',
        '#F8F8FA',
        '#7FB3DC',
        '#0B667F',
        '#41937D',
        '#3C9EB7',
      ],
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.init()
      this.initScrollTriggers()
      this.$ScrollTrigger.refresh()
      this.setClientHeight()
      this.initVideoIcon('.ratings-video-icon', () => this.openModal())

      this.returnedFunction = this.$debounce(() => {
        this.$ScrollTrigger.refresh()
        this.setClientHeight()
      }, 250)

      window.addEventListener('resize', this.returnedFunction)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.returnedFunction)
  },
  methods: {
    init() {
      this.navEl = document.querySelector('#nav-header-pin')
      // this.swipePanels = this.$gsap.utils.toArray('.swipe-section .panel')
      this.sections = this.$gsap.utils.toArray('.swipe-section section')
      this.swipeContainer = this.$refs.swipeContainer

      // set bg color
      this.$gsap.set(this.$refs.swipeContainer, {
        background: '#F8F8FA',
      })

      if (this.$matchMedia('sm')) {
        this.startSetup()
        this.arrowsSetup()
        this.hsrSetup()
        this.performanceSetup()
        this.equitySetup()
        this.wasSetup()
        this.sealTextSetup()
      }
    },
    startSetup() {
      // initial anim: container
      this.$gsap.from(this.$refs.swipeContainer, {
        opacity: 0,
        duration: 2,
      })

      // set intial position of ring
      if (!this.$matchMedia('sm')) {
        this.$gsap.set(this.$refs.sealContainer, {
          y: -90,
        })
      }

      // set all seals to opacity 0
      this.$gsap.set(
        [
          '.hsr-seal',
          '.performance-seal',
          '.equity-seal',
          '.was-seal',
          'blur-bg ',
        ],
        {
          opacity: 0,
        }
      )

      // set transform origin for center rotation
      this.$gsap.set(['.seal-rings', '.seal-arrows', '.seal-outer-circle'], {
        transformOrigin: 'center',
      })

      // hide arrows
      this.$gsap.set('.seal-arrows', {
        scale: 0.5,
        opacity: 0,
      })

      // play arrows
      this.$gsap.fromTo(
        '.seal-arrows',
        {
          rotate: 0,
        },
        {
          rotation: 360,
          duration: 13,
          repeat: -1,
          ease: 'linear',
        }
      )

      // initial anim: circle and lines
      this.start = this.$gsap
        .timeline()
        .to('.base-seal', {
          opacity: 1,
          duration: 0.2,
        })
        .add('drawSvg')
        .from(
          [
            '.seal-outer-circle',
            '.left-line',
            '.right-line',
            '.middle-line',
            '.left-line-extend',
            '.middle-line-extend',
            '.right-line-extend',
          ],
          {
            drawSVG: 0,
            duration: 0.8,
            stagger: 0.2,
            delay: 0.1,
          },
          '<=+.1'
        )
        .add('end')

      const tl = this.$gsap.timeline({ paused: true }).add('start')
      if (this.$matchMedia('lg')) {
        tl.to(['.equity-btn', '.performance-btn', '.hsr-btn'], {
          y: -350,
          duration: 0.5,
          stagger: 0.1,
          ease: 'Power1.easeIn',
        }).to(
          ['.left-line-extend', '.middle-line-extend', '.right-line-extend'],
          {
            y: -100,
            duration: 0.3,
          },
          '<'
        )
      }
      tl.to(
        [
          '.left-line',
          '.right-line',
          '.middle-line',
          '.left-line-extend',
          '.middle-line-extend',
          '.right-line-extend',
        ],
        {
          // y: -100,
          opacity: 0,
          duration: 0.3,
        },
        '<=+.2'
      )
      tl.to(
        ['.equity-btn', '.performance-btn', '.hsr-btn', '.explore-btn'],
        {
          opacity: 0,
          duration: 0.3,
        },
        '<=+.1'
      )
        .to(
          this.$refs.sealContainer,
          {
            y: !this.$matchMedia('lg') ? -100 : -155,
            duration: 0.5,
            ease: 'Power1.back',
          },
          '<=+.1'
        )
        .to(
          '.seal-outer-circle',
          {
            scale: 1.5,
            opacity: 0,
            duration: 0.5,
          },
          '<'
        )
        .addLabel('end')

      this.startTl = tl
    },
    arrowsSetup() {
      this.arrowsTl = this.$gsap
        .timeline({ paused: true })
        .to('.base-rings', {
          rotate: -90,
          opacity: 1,
          transformOrigin: 'center',
          duration: 0.8,
          ease: 'Power4.out',
          immediateRender: false,
          overwrite: true,
        })
        .to(
          '.seal-arrows',
          {
            scale: 1,
            opacity: 1,
            duration: 0.5,
          },
          '<=+.25'
        )
    },
    hsrSetup() {
      this.hsrTl = this.$gsap
        .timeline({ paused: true })
        .addLabel('start')
        // .to('.seal-arrows', {
        //   scale: 0.5,
        //   opacity: 0,
        //   duration: 1.5,
        //   // delay: 1.5,
        //   // immediateRender: false,
        // })
        // .to('.base-rings', {
        //   rotate: -180,
        //   transformOrigin: 'center',
        //   duration: 2,
        //   ease: 'Power1.ease',
        //   immediateRender: false,
        // })
        // .to('.base-text', {
        //   y: '-1.5rem',
        //   fill: 'white',
        //   duration: 1,
        // })

        .to(
          ['.hsr-seal'],
          {
            opacity: 1,
            duration: 0.8,
          },
          '<'
        )
        .from(
          '.hsr-rings',
          {
            rotate: -90,
            transformOrigin: 'center',
            duration: 0.8,
            ease: 'Power4.out',
          },
          '<'
        )
        // .to('.base-rings', {
        //   opacity: 0,
        //   duration: 0.5,
        // })
        .to(
          '.blur-bg',
          {
            opacity: 1,
            duration: 0.5,
          },
          '<'
        )
        .add('end')
    },
    performanceSetup() {
      this.performanceTl = this.$gsap
        .timeline({ paused: true })
        // .to('.hsr-seal', {
        //   opacity: 0,
        //   duration: 1,
        // })
        .to('.performance-seal', {
          opacity: 1,
          duration: 0.5,
        })
        .from(
          '.performance-rings',
          {
            rotate: -90,
            transformOrigin: 'center',
            duration: 0.8,
            ease: 'Power4.out',
          },
          '<'
        )
      // .to('.hsr-rings', {
      //   rotate: -90,
      //   transformOrigin: 'center',
      //   duration: 1.5,
      //   ease: 'Power2.ease',
      // })
      // .to(
      //   '.seal-bg',
      //   {
      //     fill: '#0B667F',
      //     duration: 1,
      //   },
      // step
      // )
    },
    equitySetup() {
      this.equityTl = this.$gsap
        .timeline({ paused: true })
        // .to('.performance-seal', {
        //   opacity: 0,
        //   duration: 1,
        // })
        .to('.equity-seal', {
          opacity: 1,
          duration: 0.5,
        })
        .from(
          '.equity-rings',
          {
            rotate: -90,
            transformOrigin: 'center',
            duration: 0.8,
            ease: 'Power4.out',
          },
          '<'
        )
      // .to('.performance-rings', {
      //   rotate: -90,
      //   transformOrigin: 'center',
      //   duration: 1.5,
      //   ease: 'Power2.easeOut',
      // })
      // .to(
      //   '.seal-bg',
      //   {
      //     fill: '#41937D',
      //     duration: 1,
      //   },
      //   '<'
      // )
    },
    wasSetup() {
      this.wasTl = this.$gsap
        .timeline({ paused: true })
        // .to('.equity-seal', {
        //   opacity: 0,
        //   duration: 1,
        // })

        .from('.was-rings', {
          rotate: -90,
          transformOrigin: 'center',
          duration: 0.8,
          ease: 'Power4.out',
        })
        // .to('.equity-rings', {
        //   rotate: -10,
        //   transformOrigin: 'center',
        //   duration: 0.5,
        //   ease: 'Power1.easeIn',
        // })
        // .to(
        //   '.seal-bg',
        //   {
        //     fill: '#3C9EB7',
        //     duration: 1,
        //   },
        //   '<'
        // )
        .to(
          '.was-seal',
          {
            opacity: 1,
            duration: 0.8,
          },
          '<'
        )
        .from(
          ['.was-globeline'],
          {
            drawSVG: 0,
            duration: 0.5,
          },
          '<'
        )
        .to(
          '.base-text',
          {
            y: 0,
            duration: 0.5,
          },
          '<'
        )
    },
    sealTextSetup() {
      this.sealTextTl = this.$gsap.timeline({ paused: true }).to('.base-text', {
        y: '-1.5rem',
        fill: 'white',
        duration: 0.5,
      })
    },

    initScrollTriggers() {
      this.sections.forEach((section, i) => {
        // Timeline to change background
        this.$gsap
          .timeline({
            scrollTrigger: {
              trigger: section,
              scrub: 0.5,
              start: 'top top+=50%',
              end: 'bottom bottom',
              // markers: true,
              onEnter: () => {
                if (i === 2) {
                  this.navEl.firstChild.classList.remove('transparent-bg')
                  this.navEl.firstChild.classList.add('transparent-bg-white')
                }
              },
              onLeaveBack: () => {
                if (i === 2) {
                  this.navEl.firstChild.classList.add('transparent-bg')
                  this.navEl.firstChild.classList.remove('transparent-bg-white')
                }
              },
            },
          })
          .to(['.swipe-section'], {
            backgroundColor: this.bgColors[i],
            duration: 0.5,
          })
          .to(
            '.seal-bg',
            {
              fill: this.bgColors[i],
              duration: 0.5,
            },
            '<'
          )

        // text fade
        if (!this.$matchMedia('lg')) {
          const tl = this.$gsap.timeline({
            scrollTrigger: {
              trigger: section.firstChild,
              // start: 'center top',
              // end: 'bottom+=20% top',
              start: 'center center',
              end: 'bottom center',
              scrub: true,
              // markers: true,
              // toggleActions: 'play reverse play reverse',
            },
          })
          tl.to(section.firstChild, {
            opacity: 1,
            duration: 2,
          })
          if (i !== 5) {
            tl.to(section.firstChild, { opacity: 0.2, duration: 2 }, 2)
          }
          if (i === 5) {
            tl.to(this.$refs.sealContainer, {
              opacity: 0,
              duration: 1,
            })
          }
        }

        // do not animate master seal on mobile
        if (this.$matchMedia('sm')) {
          // pin section text
          this.$gsap.timeline({
            scrollTrigger: {
              trigger: section,
              // pin: true,
              start: 'top top',
              end: 'bottom center',
              // scrub: true,
              // markers: true,
              // toggleActions: 'play reverse play reverse',
              // toggleActions: 'play none none reverse',
              preventOverlaps: true,
              fastScrollEnd: true,
              onEnter: () => {
                if (i === 0) {
                  // arrow enter
                  this.startTl.restart()
                  this.arrowsTl.restart()
                }
              },
              onLeaveBack: () => {
                if (i === 0) {
                  // start back: RESET
                  this.startTl.reverse()
                  this.arrowsTl.reverse()
                  this.sealTextTl.progress(0).pause()
                  this.hsrTl.progress(0).pause()
                  this.performanceTl.progress(0).pause()
                  this.equityTl.progress(0).pause()
                  this.wasTl.progress(0).pause()

                  // this.$gsap.to(this.$refs.sealContainer, {
                  //   opacity: 0,
                  //   duration: 0.2,
                  //   onComplete: () => {
                  //     this.startTl.restart().pause()
                  //     this.arrowsTl.restart().pause()
                  //     this.hsrTl.restart().pause()
                  //     this.performanceTl.restart().pause()
                  //     // this.equityTl.progress(0).pause()
                  //     // this.wasTl.progress(0).pause()
                  //   },
                  // })
                  // this.$gsap.to(this.$refs.sealContainer, {
                  //   opacity: 1,
                  //   duration: 0.3,
                  //   delay: 0.3,
                  // })
                }
              },
              onLeave: () => {
                if (i === 1) {
                  // hsr enter
                  this.arrowsTl.reverse()
                  this.sealTextTl.restart()
                  this.hsrTl.restart()
                }
                if (i === 2) {
                  // performance enter
                  this.hsrTl.reverse()
                  this.performanceTl.restart()
                }
                if (i === 3) {
                  // equity enter
                  this.performanceTl.reverse()
                  this.equityTl.restart()
                }
                if (i === 4) {
                  // was enter
                  this.equityTl.reverse()
                  // this.sealTextTl.reverse()
                  this.wasTl.restart()
                }

                // if (i === 5 && !this.$matchMedia('md')) {
                //   // leave final panel
                //   this.$gsap.to(this.$refs.masterSeal, {
                //     opacity: 0,
                //     duration: 0.2,
                //   })
                // }
              },
              onEnterBack: () => {
                if (i === 1) {
                  // arrow back
                  this.sealTextTl.reverse()
                  this.arrowsTl.restart()
                  this.hsrTl.timeScale(2).reverse()
                }
                if (i === 2) {
                  // hsr back
                  this.hsrTl.restart()
                  // this.hsrTl.tweenFromTo('start', 'end')
                  this.performanceTl.timeScale(2).reverse()
                }
                if (i === 3) {
                  // performance back
                  this.performanceTl.restart()
                  this.equityTl.timeScale(2).reverse()
                }
                if (i === 4) {
                  // equity back
                  // this.sealTextTl.restart()
                  this.equityTl.restart()
                  this.wasTl.timeScale(2).reverse()
                }

                // reveal seal entering back
                if (i === 5 && !this.$matchMedia('md'))
                  this.$gsap.to(this.$refs.masterSeal, {
                    opacity: 1,
                    duration: 0.3,
                    immediateRender: false,
                  })
              },
            },
          })
        }
      })

      if (this.$matchMedia('sm')) {
        // Seal animation
        this.$gsap.timeline({
          paused: true,
          scrollTrigger: {
            trigger: this.$refs.masterSeal,
            pin: !!this.$matchMedia('sm'),
            pinSpacing: false,
            start: 'top top',
            end: '500%',
            scrub: 0.5,
            // markers: true,
          },
          defaults: { duration: 1, ease: 'none' },
        })
      }
    },

    setClientHeight() {
      this.sectionHeight = this.$refs?.section?.clientHeight
    },
    openModal() {
      this.smoother && this.smoother.paused(true)
      this.showModal = true
    },
    closeModal() {
      this.smoother && this.smoother.paused(false)
      this.showModal = false
    },
  },
}
